// Layer 3 (Transformations) for ProjectEditorScene — document list ordering and
// save-hint copy. No React, no engine mutations.

import type { EditorDocument } from '@/versions/v1/shared/project-modules-seed';

export function sortDocumentsByUpdated(docs: EditorDocument[]): EditorDocument[] {
  return [...docs].sort((a, b) => b.updatedAt - a.updatedAt);
}

export function formatDocumentUpdated(updatedAt: number, now: number): string {
  const diff = now - updatedAt;
  const minutes = Math.floor(diff / 60_000);
  if (minutes < 1) return 'Updated just now';
  if (minutes < 60) return `Updated ${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `Updated ${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `Updated ${days}d ago`;
  return `Updated ${new Date(updatedAt).toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
  })}`;
}

export function saveHintFromEdit(editedAt: number | null, now: number): string {
  if (editedAt === null) return 'All changes saved';
  const diff = now - editedAt;
  if (diff < 2000) return 'Saved just now';
  const seconds = Math.floor(diff / 1000);
  if (seconds < 60) return `Saved ${seconds}s ago`;
  return 'Saved';
}

export function nextDocumentId(docs: EditorDocument[]): string {
  const max = docs.reduce((acc, doc) => {
    const n = Number.parseInt(doc.id.replace(/\D/g, ''), 10);
    return Number.isFinite(n) ? Math.max(acc, n) : acc;
  }, 0);
  return `doc-new-${max + 1}`;
}
